import React from "react";
import Layout from "../../../components/Layout";
import PageIntro from "../../../components/PageIntro";
import FinalCtaPanel from "../../../components/FinalCtaPanel";
import "../../../styles/brand.css";
import ImageBanner from "../../../components/ImageBanner";
import CertificationSteps from "./CertificationSteps";
import CertificationApproach from "./CertificationApproach";
import CertificationIndustries from "./CertificationIndustries";
import CertificationFaq from "./CertificationFaq";
import ContactSection4 from "../../contact/ContactSection4";
import {
  certificationSeo,
  faqContent,
  finalCtaContent,
  heroContent,
} from "./certificationContent";

/* The API-driven `Section1` block that used to sit under the banner is no
   longer rendered: it showed one CMS category image plus a single paragraph,
   which the approved document's own introduction and six-step journey now
   cover in full. The file is left on disk rather than deleted, so restoring it
   is a one-line change if that CMS image is still wanted. */

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}/Certifications`;

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: heroContent.h1,
    description: certificationSeo.description,
    url: CANONICAL,
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqContent.items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  },
];

const Certification = () => (
  <Layout
    title={certificationSeo.title}
    description={certificationSeo.description}
    keywords={certificationSeo.keywords}
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="certification-page brand-page bg-white">
      <ImageBanner
        src="/assets/banners/our-certification-process.png"
        alt="Our Certification Process — MBA Solutions"
        width={1149}
        height={615}
      />

      <PageIntro
        id="certification-hero-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <CertificationSteps />
      <CertificationApproach />
      <CertificationIndustries />
      <CertificationFaq />
      <FinalCtaPanel
        id="certification-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        secondaryCta={finalCtaContent.secondaryCta}
        image="/assets/cta/certification-journey.webp"
      />

      {/* the page's existing enquiry form, kept — and now the target of the
          closing CTA's second button */}
      <div id="certification-enquiry" className="scroll-mt-24 pt-8 pb-4">
        <ContactSection4 />
      </div>
    </main>
  </Layout>
);

export default Certification;
